import { action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import localStorage from '../../utils/localStorage';

const companyIdKey = 'companyId';
const customerIdKey = 'customerId';
const roomNoKey = 'roomNo';
const lastNameKey = 'lastName';
const adminLoginNameKey = 'adminLoginName';
const adminLoginPasswordKey = 'adminLoginPassword';
const adminLoginRoleKey = 'adminLoginRole';
const adminLoginTokenKey = 'adminLoginToken';

class loginStore {
    @action getRoomNo() {
        var companyId = localStorage.Get(companyIdKey);
        var customerId = localStorage.Get(customerIdKey);
        var roomNo = localStorage.Get(roomNoKey);

        if (companyId === null || customerId === null || roomNo === null) {
            return null;
        }

        return `${companyId}_${customerId}_${roomNo}`;
    }

    @action authenticateGuest() {
        let companyId = '';
        let lastName = '';
        let roomNo = '';

        if (window.localStorage.getItem(companyIdKey)) {
            companyId = window.localStorage.getItem(companyIdKey);
        }

        if (window.localStorage.getItem(lastNameKey)) {
            lastName = window.localStorage.getItem(lastNameKey).replace(/["]+/g, '');
        }

        if (window.localStorage.getItem(roomNoKey)) {
            roomNo = window.localStorage.getItem(roomNoKey).replace(/['"]+/g, '');
        }

        return ApiCaller.User.apiLoginAsGuest(companyId, roomNo, lastName, '').then((guestLoginResponse) => {
            if (guestLoginResponse) {
                if (guestLoginResponse.success) {
                    if (guestLoginResponse.result) {
                        return true;
                    }
                }
            }

            this.removeLoginInformation();
            return false;
        });
    }

    @action removeLoginInformation() {
        window.localStorage.removeItem(companyIdKey);
        window.localStorage.removeItem(lastNameKey);
        window.localStorage.removeItem(roomNoKey);
    }

    @action authenticateAdmin() {
        let adminLoginName = '';
        let adminLoginPassword = '';
        let adminLoginToken = '';

        if (window.localStorage.getItem(adminLoginNameKey)) {
            adminLoginName = window.localStorage.getItem(adminLoginNameKey).replace(/["]+/g, '');
        }

        if (window.localStorage.getItem(adminLoginPasswordKey)) {
            adminLoginPassword = window.localStorage.getItem(adminLoginPasswordKey).replace(/['"]+/g, '');
        }

        if (window.localStorage.getItem(adminLoginTokenKey)) {
            adminLoginToken = window.localStorage.getItem(adminLoginTokenKey).replace(/['"]+/g, '');
        }

        if (adminLoginToken) {
            return ApiCaller.User.AdminLoginToken(adminLoginToken).then(resp => {
                if (resp) {
                    if (!resp.isError) {
                        if (resp.userModel) {
                            return true;
                        }
                    }
                }
    
                this.removeAdminLoginInformation();
                return false;
            });
        }

        return ApiCaller.User.AdminLogin(adminLoginName, adminLoginPassword).then(resp => {
            if (resp) {
                if (!resp.isError) {
                    if (resp.userModel) {
                        return true;
                    }
                }
            }

            this.removeAdminLoginInformation();
            return false;
        });
    }

    @action removeAdminLoginInformation() {
        window.localStorage.removeItem(adminLoginNameKey);
        window.localStorage.removeItem(adminLoginPasswordKey);
        window.localStorage.removeItem(adminLoginRoleKey);
    }
}

export default new loginStore()